/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
import { withRouter } from 'react-router'
// actions
import { createEmbed, updateEmbed } from 'state/actions/embedsState/embedManagementState/selected_embed_status';
import { updateStepDetails } from 'state/actions/embedsState/embedManagementState/embed_management_status';
import { moveToLibrary } from 'state/actions/embedsState/embeds_status';
import { resetEmbedState } from 'state/actions/embedsState/embedManagementState/selected_embed_status';
import { resetContentState } from 'state/actions/embedsState/embedManagementState/content_status';
import { setEditMode } from '@insticator/insticator-ui';
// utils
import { batchActions } from 'redux-batched-actions';
// components
import EmbedManagement from 'pages/dashboard/embeds/management/embed_management';



/* ========== ~~~~~~~~~~ EMBED MANAGEMENT : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({ embedsState, sessionStatus }) => ({
    accountUUID: sessionStatus.accountUUID,
    isDataReceived: embedsState.embedsStatus.isDataReceived || (!!sessionStatus.mockupGenerator && !!sessionStatus.embedUUID),
    currentStepPage: embedsState.embedManagementState.embedManagementStatus.currentStepPage,
    embedName: embedsState.embedManagementState.selectedEmbedStatus.selectedEmbedData.embedName,
    embedUUID: embedsState.embedManagementState.selectedEmbedStatus.selectedEmbedData.embedUUID,
    executorUUID: !!sessionStatus.executorUUID ? sessionStatus.executorUUID : 'none',
    selectedEmbedStatus: embedsState.embedManagementState.selectedEmbedStatus,
    contentStatus: embedsState.embedManagementState.contentStatus,
    isNewEmbedFlow: embedsState.embedManagementState.selectedEmbedStatus.selectedEmbedData.isNewEmbedFlow,
    isSavingData: embedsState.embedManagementState.selectedEmbedStatus.selectedEmbedData.isSavingData,
    changeDetected: embedsState.embedManagementState.selectedEmbedStatus.selectedEmbedData.embedChangeDetected ||
        embedsState.embedManagementState.contentStatus.contentChangeDetected
});
// map actions
const mapDispatchToProps = dispatch => ({
    createEmbed: (siteUUID, data) => dispatch(createEmbed(siteUUID, data)),
    updateEmbed: (siteUUID, embedUUID, data) => dispatch(updateEmbed(siteUUID, embedUUID, data)),
    updateStepDetails: location => dispatch(updateStepDetails(location)),
    setEditMode: editState => dispatch(setEditMode(editState)),
    moveToLibrary: () => dispatch(moveToLibrary()),
    resetEmbedAndContentState: () => dispatch(batchActions([
        resetEmbedState(),
        resetContentState({ setInitialContentId: false }),
    ]))
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(EmbedManagement));
